import React, { useMemo, useState, useEffect } from "react";
import { AiFillFileAdd, AiOutlineClose, AiFillFile } from "react-icons/ai";
import { useDropzone } from "react-dropzone";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import Modal from "react-bootstrap/Modal";
import Image from "react-bootstrap/Image";
import COLORS from "scss/colors.module.scss";
import ApiClient from "utils/ApiClient";
import { CircularProgress } from "@material-ui/core";

const baseStyle = {
  flex: 1,
  display: "flex",
  height: "100%",
  position: "absolute",
  top: "0",
  right: "25px",
  left: "25px",
  width: "auto",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  cursor: "pointer",
  outline: "none",
  transition: "border .24s ease-in-out",
  margin: "auto",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

var count = 0;
export function UploaderPopup(props) {
  const [files, setFiles] = useState([]);
  const [nonImageFiles, setNonImageFiles] = useState([]);
  const [canvas, setCanvas] = useState(1);
  const [isUploading, setIsUploading] = useState(false);
  const { allowed_file_types } = props;
  const acceptTypes = useMemo(() => {
    if (!allowed_file_types || !Array.isArray(allowed_file_types) || allowed_file_types.length === 0) {
      return null;
    }
    return allowed_file_types.map(type => type.replace(/\s/g, "")).join(",");
  }, [allowed_file_types]);
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    open,
  } = useDropzone({
    accept: acceptTypes,
    onDrop: (acceptedFiles) => {
      acceptedFiles.map((file) => {
        {
          if (file.type !== "image/png" && file.type !== "image/jpeg") {
            setNonImageFiles((nonImageFiles) => [...nonImageFiles, file]);
          } else {
            setFiles((files) => [
              ...files,
              Object.assign(file, {
                preview: URL.createObjectURL(file),
                id: count,
              }),
            ]);
            count++;
          }
          setCanvas((canvas) => 1);
        }
      });
    },
  });

  document.onpaste = function (event) {
    var items = (event.clipboardData || event.originalEvent.clipboardData)
      .items;
    for (const index in items) {
      var item = items[index];
      if (item.kind === "file") {
        var blob = item.getAsFile();
        var pastedFiles = [];
        pastedFiles.push(blob);
        setFiles([
          ...files,
          Object.assign(blob, {
            preview: URL.createObjectURL(blob),
            id: count,
          }),
        ]);
        count++;

        setCanvas((canvas) => 1);
        // setShow(false)
      }
    }
  };

  const handleKeyDown = function (event) {
    if (event.key === "Enter") {
      if (files.length > 0 || nonImageFiles.length > 0) {
        uploadFiles();
      }
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [files, nonImageFiles]);

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : { borderColor: COLORS.TEXT_COLOR }),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  const handleClosemodal = () => {
    props.setShowModal(false);
    setCanvas((canvas) => 1);
    removeAll();
  };

  const handleSave = () => {
    const data = [];

    [...files, ...nonImageFiles].forEach((file) => {
      if (file.uploadStatus == "uploaded") {
        data.push(file.uploadedData);
      }
    });

    props.onChange(data);
    handleClosemodal();
  };

  const removeHandlerFiles = (index1) => {
    files.splice(index1, 1);
    setFiles([...files]);
  };
  const removeHandlernonImageFiles = (index2) => {
    nonImageFiles.splice(index2, 1);
    setNonImageFiles([...nonImageFiles]);
  };

  const removeAll = () => {
    files.splice(0, files.length);
    nonImageFiles.splice(0, nonImageFiles.length);
    setFiles([...files]);
    setNonImageFiles([...nonImageFiles]);
  };

  const updateCanvas = () => {
    setCanvas((canvas) => 0);
  };
  const canvasUpdating = () => {
    setCanvas((canvas) => 1);
  };

  const uploadFiles = async () => {
    const max_files=props.max_files;
    if(props.fileCount + Object.keys(nonImageFiles).length + Object.keys(files).length > max_files){
      window.appStore.notificationStore.showNotification(
        `You cannot upload more than ${max_files} file(s).`,
        "error"
      );
      return ;
    }
    setIsUploading(true);
    const fileKeys = [];
    const formData = new FormData();

    Object.keys(files).forEach((key) => {
      let file = files[key];

      if (file.uploadStatus == "uploaded") {
        return;
      }

      fileKeys.push({ key, type: "image" });
      formData.append("Filedata[]", file, file.name);
    });

    Object.keys(nonImageFiles).forEach((key) => {
      let file = nonImageFiles[key];

      if (file.uploadStatus == "uploaded") {
        return;
      }

      fileKeys.push({ key, type: "file" });
      formData.append("Filedata[]", file, file.name);
    });

    let resp;
    try {
      resp = await ApiClient.File.tempUpload(formData);
    } catch (err) {
      setIsUploading(false);
      console.log(err);
      return;
    }

    resp.files.forEach((uploadedFile, key) => {
      uploadedFile.filepath = uploadedFile.uploaded_name;
      uploadedFile.fullpath = uploadedFile.path;
      if (fileKeys[key].type == "image") {
        files[fileKeys[key].key].uploadStatus = uploadedFile.status;
        files[fileKeys[key].key].uploadedData = uploadedFile;
        setFiles([...files]);
      } else {
        nonImageFiles[fileKeys[key].key].uploadStatus = uploadedFile.status;
        nonImageFiles[fileKeys[key].key].uploadedData = uploadedFile;
        setNonImageFiles([...nonImageFiles]);
      }
    });

    setIsUploading(false);
    if (getUploadButtonCount() == 0) {
      handleSave();
    }
  };

  const getUploadButtonText = () => {
    const isUploadStatusFailed = [...files, ...nonImageFiles].find((file) => {
      return file.uploadStatus == "failed";
    });

    if (isUploadStatusFailed) {
      return "Retry Upload";
    }

    return "Upload";
  };

  const getUploadButtonCount = () => {
    let count = 0;

    [...files, ...nonImageFiles].forEach((file) => {
      if (file.uploadStatus != "uploaded") {
        count++;
      }
    });

    return count;
  };
  const uploadButtonCount = getUploadButtonCount();

  return (
    <Modal
      size="lg"
      dialogClassName="custom-dialog"
      show={props.showModal}
      onHide={handleClosemodal}
      scrollable={true}
    >
      <Modal.Header style={{ border: "none" }}>
        <Modal.Title style={{ textAlign: "center", width: "100%" }}>
          {files.length > 0 || nonImageFiles.length > 0 ? (
            [
              canvas === 1 ? (
                <h4 className="uploadHeadings">Selected Files</h4>
              ) : (
                <h4 className="uploadHeadings">Upload More Files</h4>
              ),
            ]
          ) : (
            <h4 className="uploadHeadings">Upload Files</h4>
          )}
        </Modal.Title>
        <AiOutlineClose
          style={{
            cursor: "pointer",
            marginLeft: "auto",
            marginRight: "3px",
            strokeWidth: "35",
            opacity: "0.6",
          }}
          onClick={handleClosemodal}
          size={14}
        />
      </Modal.Header>
      <hr
        style={{
          width: "95.5%",
          backgroundColor: "#ebebeb",
          height: "1px",
          marginBottom: "4px",
          marginTop: "26px",
        }}
      />
      <Modal.Body style={{height: "94%"}}>
        {/* height is given so that the scroll bar is not visible when limited files are present */}
        {(files.length > 0 || nonImageFiles.length > 0) && canvas === 1 ? (
          <div {...getRootProps()} style={{ outline: "none", height: "100%" }}>
            <div className="preview">
              {/* <Badge variant="warning">{files.length}</Badge> */}
              <h5
                style={{
                  fontSize: "12px",
                  marginBottom: "15px",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  color: "#555555",
                }}
              >
                IMAGES&nbsp;
              </h5>
              {files.map((file, index1) => {
                if (
                  file.name.includes("jpg") ||
                  file.name.includes("jpeg") ||
                  file.name.includes("png") ||
                  file.name.includes("JPG") ||
                  file.name.includes("PNG")
                )
                  return (
                    <div
                      className="clearfix"
                      key={file.id}
                      style={{
                        fontSize: "13px",
                        height: "50px",
                        display: "flex",
                        flexDirection: "row",
                        marginBottom: "10px", //To maintain gap between uploaded images
                      }}
                    >
                      <Image
                        src={file.preview}
                        fluid
                        alt="preview"
                        className="img2"
                        style={{ height: "100%" }}
                      />
                      {/* <img src={file.preview} alt="preview" className="img2" />&nbsp; */}
                      &nbsp;&nbsp;
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginTop: "auto",
                          marginBottom: "auto",
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "Roboto",
                            fontWeight: "400",
                            color: "#454545",
                          }}
                        >
                          {file.name}
                        </div>
                        <span
                          style={{
                            fontFamily: "Roboto",
                            opacity: "0.6",
                            fontSize: "12px",
                          }}
                        >
                          {Math.floor(file.size / 1024)}KB
                        </span>
                      </div>
                      <div
                        style={{
                          marginLeft: "auto",
                          marginTop: "auto",
                          marginBottom: "auto",
                        }}
                      >
                        <FileUploadStatus file={file} />
                        <AiOutlineClose
                          name={index1}
                          style={{
                            cursor: "pointer",
                            stroke: "black",
                            strokeWidth: "35",
                            opacity: "0.6",
                          }}
                          onClick={() => removeHandlerFiles(index1)}
                          size={14}
                        />
                      </div>
                    </div>
                  );
              })}

              {/* <Badge variant="warning">{nonImageFiles.length}</Badge> */}
              <h5
                style={{
                  fontSize: "12px",
                  marginTop: "10px",
                  marginBottom: "20px",
                  fontFamily: "Roboto",
                  fontWeight: "500",
                  color: "#555555",
                }}
              >
                FILES&nbsp;
              </h5>

              {nonImageFiles.map((file, index2) => {
                return (
                  <div
                    className="clearfix"
                    key={index2}
                    style={{
                      fontSize: "13px",
                      display: "flex",
                      flexDirection: "row",
                      height: "auto",
                      marginBottom: "10px", //To maintain gap between uploaded files
                    }}
                  >
                    <span class="dot">
                      <center>
                        <AiFillFile
                          style={{
                            marginTop: "10px",
                            marginBottom: "10px",
                            opacity: "0.8",
                          }}
                          size={18}
                        />
                      </center>
                    </span>
                    {/* <img src={file.preview} className="img2" /> */}
                    &nbsp;&nbsp;
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "Roboto",
                          fontWeight: "400",
                          color: "#454545",
                        }}
                      >
                        {file.name}
                      </div>
                      <span
                        style={{
                          opacity: "0.5",
                          fontFamily: "Roboto",
                          fontSize: "12px",
                        }}
                      >
                        {Math.floor(file.size / 1024)}KB
                      </span>
                    </div>
                    <div
                      style={{
                        marginLeft: "auto",
                        marginTop: "auto",
                        marginBottom: "auto",
                      }}
                    >
                      <FileUploadStatus file={file} />
                      {/* <AiOutlineClose name={file.name} style={{cursor: 'pointer'}}  onClick={removeHandlernonImageFiles} size={30}/> */}
                      <AiOutlineClose
                        name={index2}
                        style={{
                          cursor: "pointer",
                          stroke: "black",
                          strokeWidth: "35",
                          opacity: "0.6",
                        }}
                        onClick={() => removeHandlernonImageFiles(index2)}
                        size={14}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div className="container">
            {/* {canvas===0?<IoMdArrowRoundBack style={{cursor: 'pointer'}} onClick={canvasUpdating} size={30} />:null} */}
            <div {...getRootProps({ style })}>
              <input {...getInputProps()} />
              <div style={{ color: "blue", opacity: "0.9" }}>
                <AiFillFileAdd size={80} />
              </div>
              <br />
              <h4 style={{ color: "black", fontSize: "20px" }}>
                Select Files to Upload
              </h4>
              <p style={{ color: "black", opacity: "0.6", fontSize: "13px" }}>
                or Drag and Drop, Copy and Paste <b>Files</b> or <b>Screenshots</b>
              </p>
              {acceptTypes && (
                <p style={{ fontSize: '12px', color: '#757575', marginTop: '10px' }}>
                  Allowed types: {acceptTypes}
                </p>
              )}
            </div>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={{ border: "none" }}>
        <hr
          style={{
            width: "100%",
            backgroundColor: "#ebebeb",
            height: "0.5px",
            marginBottom: "10px",
          }}
        />
        {files.length > 0 || nonImageFiles.length > 0 ? (
          [
            canvas === 1 ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  flex: 1,
                  marginBottom: "0px",
                }}
              >
                <div>
                  {uploadButtonCount > 0 && (
                    <Button
                      style={{ fontFamily: "Roboto", fontSize: "13px" }}
                      variant="primary"
                      onClick={uploadFiles}
                      disabled={isUploading}
                    >
                      <div
                        style={{
                          paddingLeft: "4px",
                          paddingRight: "4px",
                          paddingTop: "1px",
                          paddingBottom: "1px",
                          borderRadius: "4%",
                        }}
                      >
                        {getUploadButtonText()} &nbsp;
                        <Badge
                          style={{
                            borderRadius: "50%",
                            paddingLeft: "6px",
                            paddingRight: "6px",
                            paddingTop: "5px",
                            paddingBottom: "5px",
                            color: "#0275d8",
                            fontFamily: "Roboto",
                            fontWeight: "500",
                          }}
                          variant="light"
                        >
                          {uploadButtonCount}
                        </Badge>
                        {isUploading && (
                          <CircularProgress size={10} color={"inherit"} />
                        )}
                      </div>
                    </Button>
                  )}

                  {uploadButtonCount === 0 && (
                    <Button
                      style={{
                        fontFamily: "Roboto",
                        fontSize: "13px",
                        fontWeight: "500",
                        opacity: "0.90",
                      }}
                      variant="primary"
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  )}
                </div>
                &nbsp;&nbsp;
                <div>
                  <Button
                    style={{
                      fontFamily: "Roboto",
                      fontSize: "13px",
                      fontWeight: "500",
                      color: "#808080",
                    }}
                    variant=""
                    onClick={updateCanvas}
                  >
                    <div style={{ paddingTop: "3px", paddingBottom: "3px" }}>
                      Upload more
                    </div>
                  </Button>
                </div>
                <div style={{ marginRight: "auto", marginLeft: "5px" }}>
                  <Button
                    style={{
                      fontFamily: "Roboto",
                      fontSize: "13px",
                      color: "#808080",
                      fontWeight: "500",
                    }}
                    onClick={removeAll}
                    variant=""
                  >
                    <div style={{ paddingTop: "3px", paddingBottom: "3px" }}>
                      Deselect All
                    </div>
                  </Button>{" "}
                </div>
              </div>
            ) : (
              <Button
                style={{
                  fontFamily: "Roboto",
                  fontSize: "13px",
                  fontWeight: "500",
                  opacity: "0.90",
                }}
                variant="danger"
                onClick={canvasUpdating}
              >
                Cancel
              </Button>
            ),
          ]
        ) : (
          <div>
            <Button
              style={{
                fontFamily: "Roboto",
                fontSize: "13px",
                fontWeight: "500",
                opacity: "0.90",
              }}
              variant="secondary"
              onClick={handleClosemodal}
            >
              Close
            </Button>{" "}
            &nbsp;
          </div>
        )}
      </Modal.Footer>
    </Modal>
  );
}

function FileUploadStatus({ file }) {
  return (
    <React.Fragment>
      {file.uploadStatus == "uploaded" && (
        <span style={{ color: "green" }}>Uploaded</span>
      )}

      {file.uploadStatus == "failed" && (
        <span style={{ color: "red" }}>Failed</span>
      )}
    </React.Fragment>
  );
}
